import React from "react";
import { Link } from "react-router-dom";
import "./Header.css";


function Header() {
  return (
    <header className="header-container">
      {/* LOGO + TEXT */}
      <div className="logo">
        {/* If you have a logo image, place it here */}
        <img src="/logo.png" alt="Sensasion Physiotherapy Clinic Logo"/>
        <Link to="/" className="logo-text">Sensasion Physiotherapy Clinic</Link>
      </div>

      {/* NAV MENU */}
      <nav>
        <ul className="main-nav">
          <li>
            <Link to="/">Home</Link>
          </li>
          <li className="dropdown">
            <button className="dropbtn">Services</button>
            <ul className="dropdown-content">
              <li><Link to="/services/orthopaedic">Orthopaedic Physical Therapy</Link></li>
              <li><Link to="/services/post-surgical">Post Surgical Physical Therapy</Link></li>
              <li><Link to="/services/neuro">Neuro Physical Therapy</Link></li>
              <li><Link to="/services/preoperative">Preoperative Prehabilitation</Link></li>
            </ul>
          </li>
          <li className="dropdown">
            <button className="dropbtn">About</button>
            <ul className="dropdown-content">
              <li><Link to="/about/about-us">About Us</Link></li>
              <li><Link to="/about/team">Team</Link></li>
            </ul>
          </li>
          <li className="dropdown">
            <button className="dropbtn">Patient Information</button>
            <ul className="dropdown-content">
              <li><Link to="/patient-info/what-to-expect">What to Expect</Link></li>
              <li><Link to="/patient-info/patient-portal">Patient Portal</Link></li>
              <li><Link to="/patient-info/faq">FAQ</Link></li>
            </ul>
          </li>
          <li>
            <Link to="/blog">Blog</Link>
          </li>
          <li>
            <Link to="/contact">Contact Us</Link>
          </li>
        </ul>
      </nav>
    </header>
  );
}

export default Header;
